import { Injectable } from "@angular/core";
import { AbstractService } from "./abstract.service";
import { HttpClient } from "@angular/common/http";
import { CondominioResponseDto } from "../dto/condominio-response.dto";
import { firstValueFrom } from "rxjs";

@Injectable({ providedIn: 'root' })
export class IndicadoresService {
    brasilAPI = `https://brasilapi.com.br/api`;


    constructor(private http: HttpClient) { }

    async cambioGet(moeda: string, data: string): Promise<any> {
        const response$ = this.http.get<any>(this.brasilAPI + `/cambio/v1/cotacao/${moeda}/${data}`);
        const dataResponse = await firstValueFrom(response$);
        return dataResponse;
    }

    async taxas(sigla: 'CDI' | 'SELIC' | 'IPCA'): Promise<any> {
        const response$ = this.http.get<any>(this.brasilAPI + `/taxas/v1/${sigla}`);
        const dataResponse = await firstValueFrom(response$);
        return dataResponse;
    }
    async getAllTaxas(): Promise<IndicadorEconomicoDTO[]> {
        const response$ = this.http.get<any>(this.brasilAPI + `/taxas/v1`);
        const dataResponse = await firstValueFrom(response$);
        return dataResponse;
    }
}


//[{"nome":"Selic","valor":14.75},{"nome":"CDI","valor":14.65},{"nome":"IPCA","valor":5.53}]

export interface IndicadorEconomicoDTO {
    nome: string;
    valor: number;
}
